export default __webpack_public_path__ + "static/media/hero_logo.d1cd1caf.png";